import React, { createContext, useContext } from 'react';
import useGetFeature from 'services/useGetFeature';

type FeatureToggleContextType = {
  listOfFeatures: {
    name: string;
  }[];
  accessableFeature: any[];
  underMaintenance: boolean;
  wizardUnderMaintenance: boolean;
  loading: boolean;
  error: any;
};
export const FeatureToggleContext = createContext<FeatureToggleContextType>({
  listOfFeatures: [],
  accessableFeature: [],
  underMaintenance: false,
  wizardUnderMaintenance: false,
  loading: false,
  error: null
});

export const FeatureToggleProvider = ({ children }) => {
  const data = useGetFeature();

  return <FeatureToggleContext.Provider value={data}>{children}</FeatureToggleContext.Provider>;
};

export const useFeatureToggleContext = () => {
  return useContext(FeatureToggleContext);
};
